import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Home = ({routes}) => {
    const navigate = useNavigate();
    useEffect(()=>{
        if(!routes || routes.length === 0)
            return;
        let route = routes.at(0);
        navigate(`../${route.href}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return;
}


export default Home;

